export default {
    Lang: {
        'hello': 'سلام',
        "resultTitle": "نتایج تست شنوایی",
        "subTitle": "نتایج خود را بررسی کنید و به مرحله بعد بروید",
        "glanceText": "نتایج در یک نگاه",
        "glancePerfect": "تبریک! شنوایی شما کاملا نرمال می باشد.",
        "glanceImperfect": "شما افت شنوایی خفیف دارید",
        "glanceModerate": "شنوایی شما در حد متوسط است. ممکن است در موقعیت های مختلف دچار مشکل شوید",
        "glanceSevere": "افت شنوایی شما شدید است که می تواند کیفیت زندگی شما را تحت تأثیر قرار دهد.",
        "normalText": "نرمال",
        "mildText": "خفیف",
        "moderateText": "در حد متوسط",
        "severeText": "شدید",
        "somethingToConsiderTitle": "این را باید در نظر بگیرید!",
        "ourRecommendationTitle": "پیشنهاد ما به شما",
        "overallHealth": "سلامت و کیفیت کلی زندگی شما به طور مستقیم می تواند به سلامت شنوایی تان مرتبط باشد. انجمن پزشکی آمریکا توصیه می کند که به طور منظم بررسی های شنوایی انجام دهید.",
        "adTitle": "مرحله بعدی من چیست؟",
        "adDescription": "Schedule a <strong>FREE</strong> hearing consultation at a location near you.",
        "adPhoneNumber": "<span class='sched-appt-number'>888-928-6151</span>",
        "adButtonText": "<span class='sched-appt-link'>Schedule an appointment</span>",
        "adButtonUrl": "https://starkey.com/find-a-professional",
        "hlGlanceTitle": "نتایج سوالات مشکل شنوایی در مکان های مختلف",
        "hlGood": "بر اساس جواب های شما, نتایج نشان می دهند شما در بیشتر مکان ها به راحتی می شنوید.",
        "hlBad": "بر اساس جواب های شما, نتایج نشان می دهند که ممکن است در بعضی از محیط ها مجبور باشید برای شنیدن تلاش کنید.",
        "hlAnswer_1": 'دنبال کردن و فهمیدن صحبت ها و بحث ها در تلویزیون، رادیو و موبایل ممکن است برای شما مشکل باشد',
        "hlAnswer_2": 'ممکن است برای شنیدن صدای بعضی از افراد دچار چالش شوید',
        "hlAnswer_3": 'بعضی مواقع ممکن است از مردم بخواهید که حرف خود را تکرار کنند',
        "hlAnswer_4": 'شنیدن صداهای نجوا یا افرادی که به آرامی صحبت می کنند ممکن است برای شما دشوار باشد',
        "hlAnswer_5": 'هنگامی که در اطراف گروه های بزرگتر و یا در محیط های با صدای بلند باشید شنیدن مکالمات می تواند برای شما چالش برانگیز باشد',
        "hlGlanceLearnMore": "Learn more >",
        "ptGlanceTitle": "نتایج تست تون خالص",
        "ptGlanceLearnMore": "Learn more >",
        "speechGlanceTitle": "نتایج تست گفتاری",
        "sGood": "بر اساس جواب های شما, نتایج نشان می دهد شما می توانید تفاوت بین کلماتی که صدای مشابه دارند را تشخیص دهید.",
        "sBad": "بر اساس جواب های شما, نتایج نشان می دهد ممکن است در محیط های زیر دچار مشکل شوید:",
        "sGlanceLearnMore": "Learn more >",
        "hlScheduleText": "Call <strong><span class='sched-appt-number'>888-928-6151</span></strong> or click to schedule a <strong>FREE</strong> hearing consultation today.",
        "hlScheduleButtonText": "<span class='sched-appt-link'>Schedule an appointment ></span>",
        "ptTitle": "Pure tone test results",
        "ptScheduleText": "Call <strong><span class='sched-appt-number'>888-928-6151</span></strong> or click to schedule a <strong>FREE</strong> hearing consultation today.",
        "ptScheduleButtonText": "<span class='sched-appt-link'>Schedule an appointment ></span>",
        "ptGood": "بر اساس جواب های شما, نتایج نشان می دهد که شما می توانید انواع صداهای نرم را بشنوید.",
        "ptBad": "بر اساس جواب های شما, نتایج  نشان می دهد که ممکن است برای شنیدن انواع صداها نیاز به تلاش بیشتری داشته باشید.",
        "ptVar1": "شنیدن صدای نرم، صدای نجوا و صدای کودکان ممکن است برای شما دشوار باشد.",
        "ptVar2": "مکالمات با بعضی افراد و رستورانهای شلوغ ممکن است برای شما یک چالش باشد.",
        "ptVar3": "ممکن است برای پیروی از  یک گفتگو نظیر گروه ها، مانند شام خانوادگی و یا بازی های کارتی و ... دشوار باشد.",
        "ptVar4": "مکان های بزرگ مانند تئاتر یا عبادت گاه ها دیگر برای شما لذت بخش نیست زیرا شنیدن و درک آنچه گفته می شود برای شما دشوار است.",
        "sTitle": "نتایج تست گفتاری",
        "sCorrectText": "صحیح",
        "sScheduleText": "Call <strong><strong><span class='sched-appt-number'>888-928-6151</span></strong> or click to schedule a <strong>FREE</strong> hearing consultation today.",
        "sScheduleButtonText": "<span class='sched-appt-link'>Schedule an appointment ></span>",
        "ad2ButtonText": "<a href='/hearing-aid-finder'>Hearing Aid Finder</a>",
        "ad2Title": "بهترین راه حل برای من چیست؟",
        "ad2Description": "Learn more about hearing aid styles, features, and accessories that might be right for you.",
        "printText": "پرینت نتیجه من >",
        "mediaText": "به اشتراک بگذارید:",
        "reminder": "The hearing test simulator is for informational purposes and is not intended as a diagnostic evaluation. For a complete test and evaluation of your hearing you should visit a qualified and licensed hearing care professional.",
        "speechEnvironmentsCrowd": "در جمعیت",
        "speechEnvironmentsCar": "ماشین",
        "speechEnvironmentsParty": "مهمانی",
        "speechEnvironmentsRestaurant": "رستوران",
        "speechEnvironmentsMeeting": "ملاقات",
        "speechEnvironmentsConversation": "گفتگو",
        "speechEnvironmentsHome": "خانه",
        "untreatedHearingBoldText": "بزرگسالان می توانند با درمان کم شنوایی خود 30-40% درصد توانایی های شناختی اجتماعی را بیشتر تجربه کنند.",
        "untreatedHearingStandardText": "می توانند تا 30-40% درصد توانایی های شناختی را بیشتر تجربه کنند.",
        "researchConfirmsBold": "تحقیقات نیز تایید می کنند",
        "researchConfirmsStandard": "که کاهش شنوایی می تواند بسیاری از این بیماری ها را متوقف کند یا منجر به بهبود روابط، اعتماد به نفس و کیفیت زندگی شود.",
        "submitButtonTextNormal": "دانلود راهنمای رایگان من",
        "submitButtonTextMild": "دانلود راهنمای رایگان من",
        "submitButtonTextModerate": "ارسال",
        "submitButtonTextSevere": "ارسال",
        "resultsRecommendTextWithHtmlNormal": "To learn more about better hearing,&nbsp;download our <span class='orange-text'>FREE</span> guide below.",
        "resultsRecommendTextWithHtmlModerate": "بهتر شنیدن را هم اکنون شروع کنید.<br> <span class='orange-text'>امروز</span> تماس بگیرید تا برنامه مشاوره <span class='orange-text'>رایگان</span> شنوایی را برنامه ریزی کنید.",
        "formDownloadGuideText": "راهنمای بهتر شنیدن شما برای دانلود آماده است!",
        "formFirstNameFieldLabel": "نام",
        "formLastNameFieldLabel": "نام خانوادگی",
        "formEmailFieldLabel": "ایمیل",
        "formPhoneFieldLabel": "شماره تماس",
        "formZipCodeFieldLabel": "کد پستی",
        "dialogTechUSPhoneNumber": "0912-100-9848",
        "readyForNextStep": "من برای رفتن به مرحله بعدی آماده ام",
        "callNow": "هم اکنون تماس بگیرید",
        "printResults": "پرینت نتایج من"
    }
}


// WEBPACK FOOTER //
// ./src/assets/lang.js